import { render, staticRenderFns } from "./whyDia2.vue?vue&type=template&id=f307d832&scoped=true&"
import script from "./whyDia2.vue?vue&type=script&lang=js&"
export * from "./whyDia2.vue?vue&type=script&lang=js&"
import style0 from "./whyDia2.vue?vue&type=style&index=0&id=f307d832&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f307d832",
  null
  
)

export default component.exports